export default {
  loadFailed: 'Failed to load performance settings',
  rfStrategy: {
    title: 'Wireless RF Strategy',
    smart: 'Adaptive',
    fullPower: 'Maximum RF',
    smartDesc: 'Intelligently adjusts RF power based on signal strength, more energy-efficient',
    fullPowerDesc: 'Maintains full RF power for stronger interference resistance',
  },
  battery: {
    title: 'Batterylife Calculator',
    tooltip:
      'Battery life is a reference value for continuous use at full charge under this performance mode; actual runtime varies based on usage conditions.',
    currentConfig: 'Under current config',
    fullCharge: 'Full charge lasts up to',
  },
  rfPacket: {
    title: 'Communication Protocol Settings',
    turbo: 'Turbo Protocol',
    initial: 'Initial Protocol',
  },
  keyScanRate: 'Key Scan Rate',
  reportRate: 'Report Rate',
  reportRate16k: {
    usb2: {
      title: 'Tip',
      content:
        'A USB 2.0 port or a non-genuine USB 3.0 cable has been detected. The 16K report rate is not available. To enable 16K, please use a port with a genuine USB 3.0 cable for optimal performance.',
    },
    usb3: {
      title: 'Tip',
      content:
        'Your device has been detected as connected to a USB 3.0 or higher port. To enable a 16k polling rate, please download and install the dedicated support file, and use an original or high-quality USB 3.0 cable. After installation, please unplug and reconnect the device.',
      confirm: 'Download',
    },
  },
  usbSpeed: {
    usb3: 'USB 3.0',
    usb2: 'USB 2.0',
    driverInstalled: 'installed',
    driverNotInstalled: 'not installed',
    getInfoDetail: '{usbLabel} (GetInfo[6]=0x{statusHex}, 16K driver {driverState}, data {rawHex})',
    webUsbBcd: 'WebUSB bcdUSB {major}.{minor}',
    statusUsb3With16k: 'USB 3.0 (16K available)',
    statusUsb3NoDriver: 'USB 3.0 (16K driver missing)',
    statusNotUsb3: 'Not USB 3.0 (16K unavailable)',
    statusUnknown: 'Unknown',
    detecting: 'Detecting...',
    driverLabelInstalled: 'Installed',
    driverLabelNotInstalled: 'Not installed',
    autoUsb3WithDriver: 'USB 3.0 (16K driver {state})',
    autoUsb2Unavailable: 'USB 2.0 (16K unavailable)',
    webUsbVerifyOk: '✓ WebUSB check: USB 3.0 ({detail})',
    webUsbVerifyFail: '✗ WebUSB check: not USB 3.0 ({detail})',
    webUsbVerifyUnknown: 'WebUSB check: unknown (not authorized / device not found)',
    webUsbVerifyButton: 'WebUSB check',
    verifying: 'Checking...',
    testPanel: {
      title: 'USB 3.0 Connection Check',
      guide:
        'This keyboard needs a USB 3.0 connection for 16K polling. Click to read GetInfo(0x03) offset 6 (bit0=16K driver, bit1=USB 2.0/3.0). WebHID read-only; no key action or extra authorization.',
      startButton: 'Check USB 3.0',
      sourceLabel: 'Source',
      sourceValue: 'GetInfo read-only field (WebHID)',
      driverFieldLabel: '16K driver',
      rawFieldLabel: 'Raw data bytes',
      detailUsb3Ready: 'USB 3.0 detected with 16K driver installed. 16K polling is available.',
      detailUsb3NoDriver: 'USB 3.0 detected, but the 16K driver is not installed.',
      detailNotUsb3: 'Not USB 3.0. 16K polling is unavailable; use a USB 3.0 port or cable.',
      detailUnknown:
        'Unable to determine (invalid GetInfo response). Reconnect the keyboard and retry.',
    },
  },
  sensorMode: {
    frenzy: {
      title: 'Frenzy Gaming',
      excerpt1: '≥20K engine speed',
      excerpt2: 'Ultra-fast scanning, peak performance',
    },
    competitive: {
      title: 'Gaming Hyper',
      excerpt1: '≥{scanRate}KFPS engine scan rate',
      excerpt2: 'Full-speed gaming, all-out performance',
    },
    hyperCore: {
      title: 'Hyper Core',
      excerpt1: 'Hyper core esports, microsecond response',
    },
    firepower: {
      title: 'Firepower',
      excerpt1: 'Esports gaming, effortless control',
    },
    balanced: {
      title: 'Balanced',
      excerpt1: 'Gaming entertainment, worry-free',
    },
    office: {
      title: 'Office',
      excerpt1: 'Casual gaming, office-friendly',
    },
  },
  keyboard: {
    reportRate: {
      title: 'Keyboard Polling Rate (Hz)',
      description: 'A higher polling rate reduces the impact of input latency.',
    },
    debounce: {
      title: 'Debounce Level',
      description: 'Higher values apply stronger debounce filtering before a key actuates.',
      low: 'Low',
      high: 'High',
    },
    tickRate: {
      title: 'Tick Rate',
      description: 'A higher rate can reduce error probability, but may use more system resources.',
      none: 'No Tick Rate',
      tick30: '30 Tick Rate',
      tick60: '60 Tick Rate',
    },
    toggles: {
      winLock: {
        title: 'Win Key Lock',
        description: 'Locks the Win key to prevent accidental presses during gameplay.',
      },
      fullAntiGhosting: {
        title: 'N-Key Rollover',
        description: 'Switches from 6-key rollover to N-key rollover for special scenarios.',
      },
      adaptiveCalibration: {
        title: 'Adaptive Dynamic Calibration 2.0',
        description: 'Automatically calibrates key travel during use to keep actuation stable.',
      },
      bottomOutStabilization: {
        title: 'Bottom-Out Stabilization',
        description: 'Reduces false triggers at bottom-out. Enable when you need stable input.',
      },
      macMode: {
        title: 'MAC Mode',
        description: 'Switches to a keyboard layout optimized for macOS.',
      },
      swapWASD: {
        title: 'Swap WASD',
        description: 'Swaps the arrow keys with WASD.',
      },
      lockAltTab: {
        title: 'Lock ALT+TAB',
        description: 'Prevents accidental window switching.',
      },
      lockAltF4: {
        title: 'Lock ALT+F4',
        description: 'Prevents accidentally closing programs.',
      },
    },
  },
}
